import React from "react";

export default ({ graphic, heading, children }) => (
  <div className="virtue">
    <div className="graphic">{graphic}</div>
    <h2>{heading}</h2>
    {children}
  </div>
);
